// Drill-down request for the Sales Dashboard: scoping filters + the clicked
// dimension/value and which tab (deposits vs clients) to page through.
export default function (other) {
  other = other || {};
  return {
    range: {
      from: other.range?.from || null,
      until: other.range?.until || null,
    },
    orgIds: other.orgIds || [],
    buIds: other.buIds || [],
    buTypes: other.buTypes || [],
    affiliateId: other.affiliateId || null,
    banner: other.banner || null,
    campaign: other.campaign || null,
    realOnly: other.realOnly == null ? null : other.realOnly,
    dimension: other.dimension || null,
    value: other.value != null ? String(other.value) : null,
    tab: other.tab || 'DEPOSITS',
    pagination: other.pagination || { page: 1, size: 25 },
  };
}
